module.exports = __webpack_public_path__ + "assets/images/25HB.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25HB.png
// module id = 1293
// module chunks = 1